export const GeneralParameters = {
  purchaseModule: "ModuloCompras",
  orderModule: "ModuloPedidos",
  freight: "GeneraFletes",
  printStoreDocument: "ImprimirBodegaDocumento",
  quotationsModule: "ModuloCotizaciones",
  requireQuotationForOrder: "ObligaCotizacionPedido",
  equipmentDispatchWithoutOrder: "DespachoEquipoSinPedido",
  accessoryDispatchWithoutOrder: "DespachoAccesorioSinPedido",
  handlesSalesRemission: "ManejaRemisionesVenta",
  swReservation: "Reserva",
  maintenanceOrder: "OrdenesDeMantenimiento",
  maintenanceStrategy: "EstrategiaMantenimiento",
  maintenanceScheduling: "OrdenMatenimientoProgramada",
  swShowOnlyOrderBreakdown: "MostrarSoloDespiecePedidos",
  transportInvoice: "FacturaTransporte"
}
